import React, { useEffect } from 'react'
import HeaderImage from '../../img/programmers-header-reverse.svg'
import FooterImage from '../../img/programmers-footer.svg'
import { Container, Grid } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { Fab } from '@material-ui/core'
import { makeStyles, lighten } from '@material-ui/core/styles'
import { Helmet } from 'react-helmet'


const useStyles = makeStyles(theme => ({
    login: {
        // width: '15vw',
        color: 'white',
        background: '#d7bb77',
        '&:hover, &:focus': {
            background: lighten('#d7bb77', .5),
            border: 'none'
        },
    },
    register: {
        // width: '15vw',
        color: 'white',
        background: '#00AD9F',
        '&:hover, &:focus': {
            background: lighten('#00AD9F', .5),
            border: 'none'
        },
    }
}))

const People = () => {
    const styles = useStyles()
    useEffect(() => {
        window.scrollTo(0, 0)
    })

    return (
        <>
            <Helmet>
                <title>منم ، هویت دیجیتالی تو - کاربران عادی</title>
            </Helmet>

            <main id="people">

                <section id='section-1'>
                    <img src={HeaderImage} alt='' />
                </section>

                <Container maxWidth='md'>
                    <section id="section-2">
                        <h2>مَنَم، برای کاربران اینترنتی</h2>
                        <p>مَنَم، یک سرویس ارائه احراز هویت است، علاوه بر مزیت‌هایی که برای سایت و  اپلیکیشن‌های مختلف دارد، برای کاربران اینترنتی نیز سرویسی بسیار کاربردی محسوب می‌شود. در طی سال‌های اخیر که فضای مجازی و اینترنت سمت سوی افزایش رضایت کاربران را به خود گرفته، وجود سرویس‌هایی مثل «مَنَم» فرآیندی ارزشمند را برای صرفه جویی و راحتی کاربران ایجاد می‌نماید.</p>

                        <hr />

                        <h2>ورود یکپارچه به سایت‌های مختلف</h2>
                        <p>این روزها با مشغله‌های زیاد، کسی از رمز عبور دل خوشی ندارد و مدیریت چند رمز عبور هم کار بسیار دشواری است. برای حذف سختی داشتن چند رمز عبور همزمان و تقویت امنیت، می‌توانید از «سیستم ورود یکپارچه‌ی سرویس احراز هویت منم» استفاده کنید تا بتوانید با یک کلیک به تمام سرویس‌های نرم‌افزاری و اپلیکیشن‌هایی که از «مَنَم» سرویس می‌گیرند، دسترسی داشته باشید. «منم» شما را قادر می‌سازد تا فقط با یک مرحله‌ی احراز هویت و ثبت‌نام (Log in) به همه چیز دسترسی داشته باشید. شما می‌توانید مراحل احراز هویت را افزایش دهید و حتی از احراز هویت چند مرحله‌ای استفاده کنید.</p>

                        <hr />

                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6} className='text-center'>
                                <section className='mb-5'>برای ویرایش اطلاعات خود از اینجا وارد شوید</section>
                                <Link to='/login'>
                                    <Fab id='fab1' variant='extended' className={styles.login}>ورود به منم</Fab>
                                </Link>
                            </Grid>

                            <Grid item xs={12} md={6} className='text-center'>
                                <section className='mb-5'>اگر در منم ثبت نام نکرده اید همین حالا ثبت نام کنید</section>
                                <Link to='/register'>
                                    <Fab id='fab2' variant='extended' className={styles.register}>ثبت نام در منم</Fab>
                                </Link>
                            </Grid>
                        </Grid>

                        <hr />

                        <article>
                            <h4>ورود یکپارچه چگونه کار می‌کند؟</h4>
                            <p>احراز هویت با ورود یکپارچه، به رابطه‌ بر پایه‌ی اعتماد بین دامنه‌ها (وبسایت‌ها) اتکا می‌کند. مراحل ورود یکپارچه، زمانی که می‌خواهید به یک اپ یا وبسایت وارد شوید این‌گونه است:
    ۱.وبسایت ابتدا چک می‌کند تا ببیند توسط سیستم ورود یکپارچه، احراز هویت شده‌اید یا نه که در صورت قبول احراز هویت، دسترسی ورود به سایت را به شما می‌دهد.
    ۲.اگر احراز هویت نشده باشید، شما را به سیستم ورود یکپارچه هدایت می‌کند تا وارد شوید.
    ۳.نام کاربری و رمز عبوری که برای دسترسی از آن استفاده می‌کنید را وارد می‌کنید.
    ۴.ورود یکپارچه از تامین کننده‌ی هویت یا سیستم احراز هویتی که شرکت شما استفاده می‌کند، درخواست احراز هویت می‌کند. این سیستم از هویت شما اطمینان حاصل می‌کند و سیستم ورود یکپارچه را مطلع می‌سازد.
    ۵.سیستم ورود یکپارچه، اطلاعات احراز هویت را به وبسایت منتقل می‌کند و شما را به سایت مورد نظر هدایت می‌کند.
    ۶.بعد از ورود، سایت اطلاعات مربوط به احراز هویت شما را در حالی که در سایت می‌چرخید، حمل و منتقل می‌کند تا هر بار که به صفحه‌ی جدیدی می‌روید، تایید کند که شما احراز هویت شده‌اید.
    در سیستم ورود یکپارچه، اطلاعات احراز هویت به شکل شناسه در می‌آیند.
زمانی هم که کاربر بخواهد به وبسایت مختلفی که در این مجموعه است برود، وبسایت جدید، سیستم ورود یکپارچه را بررسی می‌کند و از آنجایی که کاربر از قبل احراز هویت شده است، بدون نیاز به مراحل ورود ، هویت کاربر را برای وبسایت جدید تایید می‌کند.</p>
                        </article>

                        <article>
                            <h4>سیستم ورود یکپارچه‌ی حقیقی به چه شکل است؟</h4>
                            <p>درک تفاوت بین ورود یکپارچه و جهش رمز عبور (که گاهی اوقات به عنوان ورود یکپارچه جا زده می‌شود) اهمیت زیادی دارد. در جهش رمز عبور، شاید برای چند وبسایت یا اپلیکیشن یک نام کاربری و رمز عبور مشترک داشته باشید، اما هر بار که به وبسایت یا اپلیکیشن دیگری می‌روید، باید آن‌ها را دوباره وارد کنید. با وجود سیستم ورود یکپارچه، بعد از ورود از طریق ورود یکپارچه، می‌توانید به تمام اپلیکیشن‌ها و وبسایت‌های مورد تایید آن بدون عملیات ورود مجدد، وارد شوید. این مسئله شامل اپلیکیشن‌های ابری هم می‌شود.
احراز هویت ورود یکپارچه دیگر ماندگار شده است. سیستم‌های غیرمتمرکز روز به روز عمومی‌تر می‌شوند و احراز هویت یکی از جنبه‌های حیاتی آن‌هاست. ورود یکپارچه یکی از مشکلات بزرگ را حل می‌کند: «چگونه تعداد روزافزون کاربران یک اکوسیستم از اپلیکیشن‌ها و سرویس‌ها را مدیریت کنیم». سرویس‌هایی مانند «منم» این مشکل را به راحتی برطرف می‌کنند و باعث می‌شوند بتوانید ورود یکپارچه را به راحتی روی مجموعه‌ی خود اعمال کنید. اگر می‌خواهید برای یک اپلیکیشن یا سرویس جدید، سیستم احراز هویت قرار دهید، استفاده از سیستم ورود یکپارچه‌ی منم را فراموش نکنید.</p>
                        </article>
                    </section>
                </Container>

            </main>
        </>
    )
}

export default People